const DEVOLUCION_PROVEEDOR = (state, devolucion_proveedor) => {
    state.devolucion_proveedor = devolucion_proveedor;
};

export default {
    DEVOLUCION_PROVEEDOR,
};